
export default {
  name: 'OnOff',

  props: {
    value: {
      type: Boolean,
    },
  },

  data() {
    return {
      internValue: null,
    };
  },

  watch: {
    internValue(newValue, oldValue) {
      if (newValue !== null && newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
    value(value) {
      this.internValue = value;
    },
  },

  mounted() {
    this.internValue = this.value;
  },
};
